<script lang="ts">
      let { node, children = undefined } = $props()

      const { tag = 'p', format } = $state(node)
</script>

<svelte:element this={tag} class="lexical-quote {format}">
      <span class="tick front"></span>
      {@render children?.()}
      {#if node.children.length == 0}
            <br />
      {/if}
      <span class="tick rear"></span>
</svelte:element>

<style lang="postcss">
      .tick {
            background-image: url(/quote_green.svg);
            content: '';
            background-repeat: no-repeat;
            opacity: 0.7;
            background-size: 100%;
            height: 1em;
            width: 0.5rem;
            display: inline-block;
            aspect-ratio: 1 / 1;
            background-position: top;
            vertical-align: top;
            margin: 0.3rem;
            /*margin-left: 0.1em;*/
      }

      .tick:global(.rear) {
            margin-left: -0.1rem;
      }
      .tick:global(.front) {
            transform: scale(-1);
            margin-right: -0.2rem;
            margin-bottom: 0.2rem;
            vertical-align: bottom;
      }
</style>
